import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantConstant } from '@app-constants/tenant.constant';
import { TestlistService } from '@app-services/test/testlist.service';
@Component({
  selector: 'app-test-registration-confirm-dialog',
  templateUrl: './test-registration-confirm-dialog.component.html',
  styleUrls: ['./test-registration-confirm-dialog.component.css']
})
export class TestRegistrationConfirmDialogComponent implements OnInit {
  tenant: any = TenantConstant.tenant;
  timer: any;
  showCloseBtn: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TestRegistrationConfirmDialogComponent>,
    private testListService: TestlistService,
    private _router: Router
  ) {
    dialogRef.disableClose = false;
    this.showCloseBtn = data?.showCloseBtn != null ? data?.showCloseBtn: true;
  }

  ngOnInit(): void {
    console.log(this.data);
    this.showCloseBtn = this.data?.purchaseAgain? false:true;
  }
  ngAfterViewInit(): void {
    if(!this.data?.isClose){
      console.log('Do not close');
      
    }else{
      const timeoutAmt = this.showCloseBtn ? 4000: 3000;
      this.timer = setTimeout(() => {
        this.onClose();  
      }, timeoutAmt);
    }
  }
  purchaseAgain(){
    this.dialogRef.close('purchase');
  }
  explorePackages(){
    this.dialogRef.close();
    this._router.navigate(['/subscription/subscriptionPackages']);
  }

  onClose() {
    clearTimeout(this.timer);
    this.dialogRef.close();
    this.testListService.refreshTestData.next(true);
    if (this.data.redirect) {
      window.location.href = '/'
      //window.location.href = this.tenant == 'srichaitanya' ? "srichaitanya.infinitylearn.com" : 'infinitylearn.com';
    }
  }

}
